import { Edit, SimpleForm, TextInput, SelectInput, useRecordContext, useNotify } from 'react-admin';
import { useState } from 'react';
import { Box, Button, Chip, Stack, Typography, CircularProgress } from '@mui/material';
import PersonAddAlt1Icon from '@mui/icons-material/PersonAddAlt1';
import { useNavigate } from 'react-router-dom';
import authFetch from '../utils/authFetch';
import ActivityPanel from '../components/ActivityPanel';
import EntityTasksPanel from '../tasks/EntityTasksPanel';
import { NAVY, layout } from '../styles/ds';

const STATUS_CHOICES = [
  { id: 'new',       name: 'חדש' },
  { id: 'contacted', name: 'טופל' },
  { id: 'qualified', name: 'מתאים' },
  { id: 'closed',    name: 'סגור' },
  { id: 'converted', name: 'הומר ללקוח', disabled: true },
];

// Convert button + converted banner, shown above the form
const ConvertBar = () => {
  const record   = useRecordContext();
  const notify   = useNotify();
  const navigate = useNavigate();
  const [converting, setConverting] = useState(false);

  if (!record) return null;

  if (record.converted_customer_id) {
    return (
      <Stack direction="row" spacing={1.5} alignItems="center" px={2} pt={2}>
        <Chip label="הומר ללקוח ✓" sx={{ backgroundColor: '#D4EDDA', color: '#155724', fontWeight: 700 }} />
        <Button size="small" onClick={() => navigate(`/customers/${record.converted_customer_id}/show`)}
          sx={{ color: NAVY, fontWeight: 700 }}>
          מעבר ללקוח #{record.converted_customer_id}
        </Button>
      </Stack>
    );
  }

  const convert = async () => {
    setConverting(true);
    try {
      const res  = await authFetch(`/leads/${record.id}/convert`, { method: 'POST' });
      const body = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(body.error || 'שגיאה בהמרה');
      notify(body.linked_existing
        ? `הליד קושר ללקוח קיים: ${body.customer.first_name} ${body.customer.last_name}`
        : 'הליד הומר ללקוח חדש', { type: 'success' });
      navigate(`/customers/${body.customer.id}/show`);
    } catch (e) {
      notify(e.message, { type: 'error' });
      setConverting(false);
    }
  };

  return (
    <Stack className="crm-header" direction="row" justifyContent="space-between" alignItems="center" px={2} pt={2}>
      <Typography variant="caption" color="text.secondary">
        המרה יוצרת כרטיס לקוח מפרטי הליד (או מקשרת ללקוח קיים עם אותו טלפון)
      </Typography>
      <Button variant="contained" onClick={convert} disabled={converting}
        startIcon={converting ? <CircularProgress size={14} color="inherit" /> : <PersonAddAlt1Icon />}
        sx={{ backgroundColor: NAVY, borderRadius: 2, '&:hover': { backgroundColor: '#162d5a' } }}>
        המר ללקוח
      </Button>
    </Stack>
  );
};

const LeadActivities = () => {
  const record = useRecordContext();
  if (!record) return null;
  return (
    <Box px={2} pb={2}>
      <EntityTasksPanel entityType="lead" entityId={record.id} />
      <ActivityPanel leadId={record.id} />
    </Box>
  );
};

const LeadEdit = () => (
  <Edit title="עריכת ליד">
    <>
      <ConvertBar />
      <SimpleForm>
        <Box sx={layout.formGrid}>
          <TextInput source="first_name" label="שם פרטי" fullWidth />
          <TextInput source="last_name"  label="שם משפחה" fullWidth />
          <TextInput source="phone" label="טלפון" fullWidth />
          <TextInput source="email" label="אימייל" fullWidth />
          <TextInput source="source" label="מקור" fullWidth />
          <SelectInput source="status" label="סטטוס" choices={STATUS_CHOICES} fullWidth />
        </Box>
        <TextInput source="notes" label="הערות" multiline rows={4} fullWidth />
      </SimpleForm>
      <LeadActivities />
    </>
  </Edit>
);

export default LeadEdit;
